
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { i18nLanguage } from "../i18nLanguage.model";
import { Policy } from "../Policy.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class PoliciesTranslation extends GenericEntityBase<string> {
  private _id?: string = undefined; 
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_Language}-${this.fK_Policies}`;
    }
    return this._id;
  }

  override _isRelationEntity = true;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Language!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Policies!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  translation!: string;

  @NestedProperty({ TargetType: i18nLanguage })
  language?: i18nLanguage;

  @NestedProperty({ TargetType: Policy })
  policy?: Policy;

  GetType(): IEntityMetaData {
    return PoliciesTranslation.getMetaData();
  }
}
